module.exports = __webpack_public_path__ + "static/media/HeaderImage.669a230c.jpg";